import type { EntityType } from '../../domain/labels.js';
import type { ChildRow, RootRow, SelectedCell } from './types.js';

/** A root row, as the selection bar sends it: the whole subtree — master games included, for a studio. */
export const rootSelection = (row: RootRow): SelectedCell => ({
    type: row.type as EntityType,
    key: row.key,
    subtree: true,
    childCount: row.childCount,
    title: row.title,
    revision: row.revision,
});

/** A game row, as the selection bar sends it. */
export const childSelection = (row: ChildRow): SelectedCell => ({
    type: 'game',
    key: row.key,
    title: row.title,
    revision: row.revision,
});
